import { MutationTree, Mutation } from 'vuex';
import { IState, IEvent, IFilter } from './state';
import { ActionPayload } from './actions';

type MutationHandler<PayloadType> = (state: IState, payload: ActionPayload<PayloadType>) => any;

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, payload);
}

const setStartDate: MutationHandler<string> = (state, { payload }) => {
	state.filter.startDate = payload
}

const setEndDate: MutationHandler<string> = (state, { payload }) => {
	state.filter.endDate = payload
}

const setCategories: MutationHandler<string[]> = (state, { payload }) => {
	state.filter.categories = payload
}

const setEvents: MutationHandler<IEvent[]> = (state, { payload }) => {
	state.events = payload
}

const setLoading: MutationHandler<boolean> = (state, { payload }) => {
	state.loading = payload
}

const setTotal: MutationHandler<number> = (state, { payload }) => {
	state.total = payload
}

const setPage: MutationHandler<number> = (state, { payload }) => {
	state.page = payload
}

const setCanLoadMore: MutationHandler<boolean> = (state, { payload }) => {
	state.canLoadMore = payload
}

const setFilter: MutationHandler<IFilter> = (state, { payload }) => {
	state.filter = payload
}


const mutations: MutationTree<IState> = {
	setState: setStateMutation,
	setStartDate: setStartDate,
	setEndDate: setEndDate,
	setCategories: setCategories,
	setEvents: setEvents,
	setLoading: setLoading,
	setTotal: setTotal,
	setPage: setPage,
	setCanLoadMore: setCanLoadMore,
	setFilter: setFilter,
}

export default mutations
